module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Prez_COA-202a6c15217a5c3f706bad62b8c52100.svg";